var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, styled } from '@mui/material';
import { t } from 'i18next';
var StyledGroupLabel = styled(Box)(function (_a) {
  var theme = _a.theme;
  return {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.625, 1.5),
    backgroundColor: theme.palette.background.default
  };
});
var GroupLabelText = styled(Typography)(function (_a) {
  var theme = _a.theme;
  return {
    fontSize: '11px',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    letterSpacing: '0.5px'
  };
});
export var renderGroupedOptions = function (_a) {
  var key = _a.key,
    group = _a.group,
    children = _a.children;
  return _jsxs("li", {
    children: [!!(group === null || group === void 0 ? void 0 : group.trim()) && _jsx(StyledGroupLabel, {
      children: _jsx(GroupLabelText, __assign({
        variant: "caption"
      }, {
        children: group
      }))
    }), _jsx("ul", __assign({
      style: {
        padding: 0,
        margin: 0
      }
    }, {
      children: children
    }))]
  }, key);
};
export var getUnassignedLOB = function () {
  return t('autocomplete.unassignedLOB', {
    ns: 'translation'
  });
};
export var getLOBName = function (lobName, subLobName, unassignedLOB) {
  if (unassignedLOB === void 0) {
    unassignedLOB = getUnassignedLOB();
  }
  return [lobName, subLobName].filter(Boolean).join(': ') || unassignedLOB;
};
/**
 * Numeric-aware queue name comparator, e.g. "Queue 2" sorts before "Queue 10"
 * (plain localeCompare would put "Queue 10" first).
 */
export function compareQueueNames(a, b) {
  return (a !== null && a !== void 0 ? a : '').localeCompare(b !== null && b !== void 0 ? b : '', undefined, {
    numeric: true
  });
}
/** Returns a new array of queues sorted alphanumerically by name; does not mutate the input. */
export function sortQueuesByName(queues) {
  return __spreadArray([], queues, true).sort(function (a, b) {
    return compareQueueNames(a.name, b.name);
  });
}
export var sortByLOBName = function (a, b, unassignedLOB) {
  var _a, _b;
  if (unassignedLOB === void 0) {
    unassignedLOB = getUnassignedLOB();
  }
  if (a.lobName === unassignedLOB && b.lobName !== unassignedLOB) return 1;
  if (b.lobName === unassignedLOB && a.lobName !== unassignedLOB) return -1;
  return ((_a = a.lobName) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.lobName) !== null && _b !== void 0 ? _b : '') || compareQueueNames(a.name, b.name);
};